import { EYEBROW_CLASS } from "../lib/ui.js";

export default function Sheet({
  eyebrow,
  title,
  detail,
  actions = null,
  className = "",
  tight = false,
  diagram = false,
  expandable = false,
  children,
  ...rest
}) {
  return (
    <section
      {...rest}
      className={[
        "relative flex min-h-0 min-w-0 flex-col gap-2 overflow-hidden border border-[color:var(--line)] bg-[color:var(--panel-soft)]",
        tight ? "px-[9px] py-[10px]" : "px-[11px] py-[12px]",
        diagram
          ? "bg-[radial-gradient(circle,var(--diagram-dot)_0.9px,transparent_0.9px)] [background-size:7px_7px]"
          : "",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {(eyebrow || title || detail || actions) && (
        <div
          className={`grid gap-0 ${
            actions ? "[grid-template-columns:minmax(0,1fr)_auto] items-start" : ""
          }`}
        >
          <div>
            {eyebrow ? <div className={EYEBROW_CLASS}>{eyebrow}</div> : null}
            {title ? (
              <h2 className={`m-0 text-[15px] leading-[1.06] font-medium tracking-[-0.04em] ${eyebrow ? "mt-[5px]" : ""}`}>
                {title}
              </h2>
            ) : null}
            {detail ? (
              <p className={`m-0 text-[12px] leading-[1.3] text-[color:var(--muted)] ${title ? "mt-3" : ""}`}>
                {detail}
              </p>
            ) : null}
          </div>
          {actions}
        </div>
      )}
      {children}
    </section>
  );
}
